import exchangeApi from '../../api/exchange-api';
import messages from './exchange-foreign-interests-lang.json';
import getPosition from '../../common/js/get-position/get-position';
import date from '../../common/js/validators/date';
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import { DISPLAY_DATE_FORMAT, BACKEND_DATE_FORMAT } from '../../common/js/constants/constants';
import VueDatepicker from '@ui-common/vue-datepicker';
import VueRadioGroup from '@ui-common/vue-radio-group';

const headers = {
	residential: ['oneMonth', 'threeMonth', 'sixMonth', 'oneYear'],
	business: ['oneWeek', 'oneMonth', 'twoMonth', 'threeMonth', 'sixMonth', 'nineMonth', 'oneYear'],
	savings: ['yearlyInterest', 'yearlyEbkm', 'ebkmValue']
};

export default {
	data() {
		return {
			currentTable: 0,
			stickyTop: false,
			stickyBottom: false,
			model: {
				date: '',
				isEbkm: false
			},
			currencies: [],
			date: null,
			footers: null
		};
	},
	props: {
		interestType: {
			required: true,
			type: String,
			default: 'RESIDENTIAL'
		},
		isEbkm: {
			required: true,
			type: Boolean
		}
	},
	components: {
		VueDatepicker,
		VueRadioGroup
	},
	i18n: { messages },
	validations() {
		return {
			model: {
				date: {
					required,
					date: date(BACKEND_DATE_FORMAT)
				}
			}
		};
	},
	computed: {
		headers() {
			return headers;
		},
		dateFormat() {
			return DISPLAY_DATE_FORMAT[this.$i18n.locale];
		},
		today() {
			return moment().format(BACKEND_DATE_FORMAT);
		},
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		headerType() {
			let type;
			switch (this.interestType) {
				case 'RESIDENTIAL_SAVINGS':
				case 'BUSINESS_SAVINGS':
					type = 'savings';
					break;
				case 'BUSINESS':
					type = 'business';
					break;
				case 'RESIDENTIAL':
					type = 'residential';
					break;
				default:
					type = '';
					break;
			}
			return type;
		},
		interestedType() {
			let type;
			switch (this.interestType) {
				case 'RESIDENTIAL':
					type = '';
					break;
				case 'RESIDENTIAL_SAVINGS':
					type = '/savings';
					break;
				case 'BUSINESS':
					type = '/business';
					break;
				case 'BUSINESS_SAVINGS':
					type = '/business/savings';
					break;
				default:
					console.error(`Unknown interested type: ${this.interestType}`);
			}
			return type;
		},
		interestedTypeFooters() {
			let types;
			switch (this.interestType) {
				case 'RESIDENTIAL':
					types = 'KAM_LAK_LATRA,KAM_LAK_LEKOT';
					break;
				case 'RESIDENTIAL_SAVINGS':
					types = 'KAM_LAK_MEGTAK';
					break;
				case 'BUSINESS':
					types = 'KAM_VALL_LATRA,KAM_VALL_LEKOT';
					break;
				case 'BUSINESS_SAVINGS':
					types = 'KAM_VALL_MEGTAK';
					break;
				default:
					console.error(`Unknown interested type: ${this.interestType}`);
			}
			return types;
		}
	},
	methods: {
		onDateChange() {
			this.$v.model.$touch();
			if (this.model.date && !this.$v.model.date.$invalid) {
				this.getForeignInterest();
			}
		},
		onScroll() {
			if (this.$refs.results) {
				let scrollTop = getPosition(this.$refs.results).y;
				let clientHeight = this.$refs.results.offsetHeight - 80;
				this.stickyTop = scrollTop < 0 && scrollTop + clientHeight > 0;
				this.stickyBottom = scrollTop + clientHeight < 0;
			}
		},
		async getFooters() {
			let response = await exchangeApi.getMessages(this.interestedTypeFooters, this.model.date);
			this.footers = response.data.filter((item) => item.messageType == 'FOOTER').map((item) => item.message);
		},
		async getForeignInterest() {
			try {
				let backendDate = this.$v.model.date.$invalid ? '' : this.model.date;
				let response = await exchangeApi.getForeignInterest(this.interestedType, backendDate, this.model.isEbkm);
				this.model.date = response.data.date;
				this.date = response.data.date;
				this.currencies = response.data.currencies;
				this.getFooters();
			} catch (err) {
				console.error(err);
			}
		}
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll);
	},
	created() {
		this.model.isEbkm = this.isEbkm;
		this.model.date = moment().format(BACKEND_DATE_FORMAT);
		this.getForeignInterest();
	}
};
